import { useContext } from "react";
import { useSelector } from "react-redux";

import { getAwardText } from "../../../selectors";
import { BaseBenefitsList } from "../../BaseComponents/BaseBenefitsList";
import { BaseColumnInformation } from "../../BaseComponents/BaseColumnInformation";
import { BaseCompanyLogo } from "../../BaseComponents/BaseCompanyLogo";
import { BaseFeaturedCompanyHeader } from "../../BaseComponents/BaseFeaturedCompanyHeader";
import BaseLinkWrapper from "../../BaseComponents/BaseLinkWrapper";
import BaseReviewLink from "../../BaseComponents/BaseReviewLink";
import BaseServiceFlag from "../../BaseComponents/BaseServiceFlag";
import { BaseTrustpilotReview } from "../../BaseComponents/BaseTrustpilotReview";
import { BaseVisitLink } from "../../BaseComponents/BaseVisitLink";
import { CompanyContext } from "../../CompanyList/CompanyContext";
import { getStyles } from "./styles";
import { DEFAULT_LINK_TEXT, ThemeContext } from "./ThemeContext";

export const TCRColumnLayout = () => {
	const { company, companyIndex, isFeaturedCompany } =
		useContext(CompanyContext);
	const { linkText = DEFAULT_LINK_TEXT, hasTrustPilotWidget = true } =
		useContext(ThemeContext);
	const awardText = useSelector((state) => getAwardText(state, { company }));
	const styles = getStyles({ companyIndex });

	return (
		<div
			className={`tw-relative ${isFeaturedCompany ? "tw-mt-[2rem] tw-rounded-[0.25rem] [border:1.5px_solid_#4299e1]" : "tw-mt-[1.125rem] tw-rounded-[3px] [border-bottom:1px_solid_#f2f3f4]"}`}
		>
			<BaseFeaturedCompanyHeader {...styles.featuredCompanyHeader} />
			<div
				className={`tw-bg-white ${isFeaturedCompany ? "tw-px-[0.5rem]" : ""}`}
			>
				<div
					className={`tw-relative tw-mx-auto tw-flex tw-max-w-[500px] tw-flex-wrap tw-transition-all md:tw-max-w-none desktop:tw-flex-nowrap ${awardText ? "tw-pt-[1.85rem] xs:tw-pt-[1.5rem] desktop:tw-pt-0" : ""}`}
				>
					<BaseServiceFlag classNames={styles.serviceFlag} />
					<div
						className={`tw-flex tw-w-full tw-px-[15px] tw-pt-[15px] xs2:tw-pt-[20px] md:tw-py-[20px] md:tw-pl-[40px] md:tw-pr-[20px] desktop:tw-w-[20%] desktop:tw-px-0 ${awardText ? "desktop:tw-py-12" : "desktop:tw-py-0"}`}
					>
						<BaseLinkWrapper className="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-justify-center">
							<div className="tw-flex tw-w-full tw-items-center tw-justify-between xs2:tw-flex-wrap desktop:tw-items-start desktop:tw-justify-center">
								<div className="tw-flex tw-w-full tw-max-w-full tw-items-center tw-justify-center tw-text-center xs2:tw-max-w-[300px] md:tw-text-left">
									<BaseCompanyLogo classNames={styles.companyLogo} />
								</div>
								{hasTrustPilotWidget && (
									<BaseTrustpilotReview classNames={styles.trustpilotReview} />
								)}
							</div>
						</BaseLinkWrapper>
					</div>
					<div className="tw-float-right tw-flex tw-w-full tw-flex-wrap tw-items-start tw-justify-between tw-px-[15px] tw-py-[1.25rem] xs2:tw-px-[2.5rem] md:tw-pt-[10px] desktop:tw-w-[80%] desktop:tw-flex-nowrap desktop:tw-items-center desktop:tw-py-[15px] desktop:tw-pl-[15px] desktop:tw-pr-0 lg2:tw-p-[1.5rem]">
						<div className="tw-mx-auto tw-w-full tw-max-w-[690px] md:tw-mx-[initial]">
							<div className="tw-flex tw-flex-wrap tw-justify-between xs2:tw-justify-normal desktop:tw-flex-nowrap">
								<BaseLinkWrapper className="tw-flex tw-w-full tw-max-w-full tw-items-center desktop:tw-max-w-[305px] lg2:tw-max-w-[355px]">
									<BaseColumnInformation
										classNames={styles.columnInformation}
									/>
								</BaseLinkWrapper>
								<BaseLinkWrapper>
									<BaseBenefitsList
										{...styles.benefitsList}
										isExpandable={true}
										mobileItemsToShow={2}
									/>
								</BaseLinkWrapper>
							</div>
						</div>
						<div className="tw-mx-[15px] tw-flex tw-w-full tw-flex-wrap tw-items-center tw-justify-center xs:tw-flex-nowrap desktop:tw-w-auto lg2:tw-mr-0">
							<div className="tw-mt-[15px] tw-flex tw-w-full tw-max-w-[690px] tw-flex-col tw-flex-wrap tw-items-center tw-justify-evenly xs2:tw-flex-row-reverse md:tw-mx-[17px] md:tw-mb-0 md:tw-mt-[10px] desktop:tw-mx-0 desktop:tw-mt-0 desktop:tw-flex-col desktop:tw-items-start desktop:tw-justify-center">
								<BaseLinkWrapper className="tw-relative tw-inline-flex tw-h-[46px] tw-w-[75%] tw-max-w-[210px] tw-items-center tw-justify-evenly tw-rounded-[3px] tw-bg-[#6ac54e] tw-font-[Montserrat] tw-text-[14px] tw-font-bold tw-leading-[1] tw-text-white before:tw-h-[23px] before:tw-w-[23px] before:tw-bg-[url(/public/react-images/common/dollarImage.svg)] before:tw-bg-cover before:tw-bg-no-repeat after:tw-h-[10px] after:tw-w-[6px] after:tw-bg-[url(/public/react-images/common/forwardArrow.svg)] after:tw-bg-cover after:tw-bg-no-repeat after:tw-ease-in-out after:[transition-duration:0.4s] hover:tw-bg-[#14a929] after:hover:tw-translate-x-[5px] xs2:tw-w-[160px] xs2:tw-max-w-[initial] lg2:tw-w-[175px]">
									<BaseVisitLink>{linkText}</BaseVisitLink>
								</BaseLinkWrapper>
								<BaseReviewLink
									classNames={styles.reviewLink}
									linkText="Read Our Review"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
